module.exports = __webpack_public_path__ + "media/images/lb/065-5a6e12321ca22be625b883d4f6592f15.svg";